var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCube3D({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.04 47.08C24.04 47.08 23.86 47.06 23.78 47.02L4.28 36.52C4.1 36.42 4 36.24 4 36.04V12.04C4 11.84 4.1 11.66 4.28 11.56L23.78 1.06C23.94 0.98 24.14 0.98 24.3 1.06L43.8 11.56C43.98 11.66 44.08 11.84 44.08 12.04V36.04C44.08 36.24 43.98 36.42 43.8 36.52L24.3 47.02C24.3 47.02 24.14 47.08 24.04 47.08ZM24.58 34.12V45.64L43 35.72V12.94L33.58 18.02V28.9C33.58 29.1 33.48 29.28 33.3 29.38L24.58 34.12ZM5.08 35.72L23.5 45.64V34.12L14.78 29.38C14.6 29.28 14.5 29.1 14.5 28.9V18.02L5.08 12.94V35.72ZM24.58 22.86V32.88L32.5 28.56V18.58L24.58 22.84V22.86ZM15.58 28.58L23.5 32.9V22.88L15.58 18.62V28.6V28.58ZM16.18 17.68L24.04 21.92L31.9 17.68L24.04 13.4L16.18 17.68ZM24.04 12.26C24.04 12.26 24.22 12.28 24.3 12.32L33.04 17.08L42.4 12.04L24.04 2.16L5.68 12.04L15.04 17.08L23.78 12.32C23.78 12.32 23.96 12.26 24.04 12.26Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.18 17.68L24.04 21.92L31.9 17.68L24.04 13.4L16.18 17.68Z",
    fill: "#7CE9DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.58 22.86V32.88L32.5 28.58V18.6L24.58 22.86Z",
    fill: "#D3F8F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.58 28.58L23.5 32.88V22.86L15.58 18.6L15.58 28.58Z",
    fill: "#D3F8F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCube3D);
export default __webpack_public_path__ + "static/media/ic-cube-3d.978097a08834eb9a874a1ac7770aab3c.svg";
export { ForwardRef as ReactComponent };